import { Card, Col, Row, Table, Input } from 'antd';
import { useCompanyLimits } from './query/useCompanyLimits';
import { Link } from 'react-router-dom';
import { EditFilled, SearchOutlined } from '@ant-design/icons';
import CreateCompanyLimitList from './CreateCompanyLimitList';
import DeleteModalButton from '@/utils/components/DeleteModalButton';
import GlobalModal from '@/utils/modal/Modal';
import { useState } from 'react';
import { useDeleteApi } from '@/apiError/apiDelete';
import CompanyLimitModal from './CompanyLimitModal';
import { globalSearch } from '@/utils/search/Search';

export const CompanyLimitList = () => {
  const { data, refetch } = useCompanyLimits();
  const [isOpen, setIsOpen] = useState(false);
  const [modalType, setModalType] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [deleteReferenceId, setDeleteReferenceId] = useState();
  const [editReferenceId, setEditReferenceId] = useState();
  const [searchQuery, setSearchQuery] = useState('');
  const { mutateAsync: deleteData, isPending: deleteLoading } = useDeleteApi();
  const showDeleteModal = (referenceId) => {
    setModalType('delete');
    setIsModalVisible(true);
    setDeleteReferenceId(referenceId);
  };
  const showEditModal = (referenceId) => {
    setIsOpen(true);
    setEditReferenceId(referenceId);
  };

  const deleteHandler = async () => {
    const data = await deleteData(
      `superadmin/company/limits/${deleteReferenceId}/`,
    );
  };

  const columns = [
    {
      title: 'S.N',
      align: 'center',
      render: (_, __, index) => index + 1,
      width: 50,
    },
    {
      title: 'Admin',
      dataIndex: 'adminName',
      key: 'adminName',
      align: 'left',
    },
    {
      title: 'Max Compaines',
      dataIndex: 'maxCompanies',
      key: 'maxCompanies',
      align: 'right',
    },
    {
      title: 'Max Users',
      dataIndex: 'maxUsers',
      key: 'maxUsers',
      align: 'right',
    },
    {
      title: 'Max Branches',
      dataIndex: 'maxBranches',
      key: 'maxBranches',
      align: 'right',
    },
    {
      title: 'Action',
      align: 'center',
      width: 100,
      render: (record) => (
        <>
          <div className="ant-action tw-flex tw-gap-4 tw-justify-center">
            <div
              onClick={() => showEditModal(record?.referenceId)}
              className="ant-button-edit"
            >
              <Link to="" size="medium" className="edit">
                <EditFilled />
              </Link>
            </div>
            <DeleteModalButton
              showCancelModal={showDeleteModal}
              data={record?.referenceId}
            />
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="table">
        <Row gutter={[24, 0]}>
          <Col xs={24} xl={24}>
            <Card
              variant="outlined"
              title={
                <CreateCompanyLimitList
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  refetch={refetch}
                />
              }
              extra={
                <div className="flex flex-col items-center justify-center">
                  <Input
                    className="header-search"
                    name="query"
                    value={searchQuery}
                    placeholder="Search..."
                    prefix={<SearchOutlined />}
                    onChange={(event) => setSearchQuery(event.target.value)}
                  />
                </div>
              }
            >
              <div className="overflow-x-auto">
                <Table
                  size="large"
                  bordered
                  tableLayout="auto"
                  onHeaderRow={() => ({
                    style: { whiteSpace: 'nowrap' },
                  })}
                  columns={columns?.map((col) => ({
                    ...col,
                    onCell: () => ({
                      style: {
                        padding: '6px 10px',
                      },
                    }),
                  }))}
                  scroll={{ x: true }}
                  className="ant-border-space"
                  style={{ textAlign: 'center', padding: '15px' }}
                  pagination={false}
                  dataSource={globalSearch(data?.data?.data, searchQuery) || []}
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>
      <GlobalModal
        isVisible={isModalVisible}
        type={modalType}
        onClose={() => setIsModalVisible(false)}
        onConfirm={async () => {
          await deleteHandler();
          refetch();
          setIsModalVisible(false);
        }}
        loading={deleteLoading}
      />
      <CompanyLimitModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        refetch={refetch}
        id={editReferenceId}
        setEditReferenceId={setEditReferenceId}
      />
    </>
  );
};
